import PageSeo from '@/components/feature/PageSeo'
import { SITE_URL } from '@/utils/schema'
import { brandInfo } from '@/mocks/site'
import type { StoryDetail } from '@/mocks/weddingStories'

interface WeddingStoryDetailSeoProps {
  story: StoryDetail
}

export default function WeddingStoryDetailSeo({ story }: WeddingStoryDetailSeoProps) {
  const title = `${story.couple}: A ${story.type} in ${story.place} | Shabi Media`
  const description = `${story.couple}'s real wedding story — a ${story.type.toLowerCase()} in ${story.place} on ${story.date}, photographed by Shabi Media. See the rituals, timeline and photo story.`

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: `${story.couple} — A ${story.type} in ${story.place}`,
    description: story.excerpt,
    image: story.images.map((item) => item.image),
    articleSection: 'Real Wedding Story',
    inLanguage: 'en',
    author: {
      '@type': 'Organization',
      name: brandInfo.name,
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: brandInfo.name,
      logo: {
        '@type': 'ImageObject',
        url: brandInfo.logoImage,
      },
    },
    about: {
      '@type': 'Event',
      name: `Wedding of ${story.couple}`,
      eventType: 'Wedding',
      location: {
        '@type': 'Place',
        name: `${story.place}, Tamil Nadu`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}${story.to}`,
    },
  }

  return <PageSeo title={title} description={description} path={story.to} schemas={[articleSchema]} />
}